import { render, staticRenderFns } from "./CreaAsta.vue?vue&type=template&id=fcb31d8a&scoped=true&"
import script from "./CreaAsta.vue?vue&type=script&lang=js&"
export * from "./CreaAsta.vue?vue&type=script&lang=js&"
import style0 from "./CreaAsta.vue?vue&type=style&index=0&id=fcb31d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb31d8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcb31d8a')) {
      api.createRecord('fcb31d8a', component.options)
    } else {
      api.reload('fcb31d8a', component.options)
    }
    module.hot.accept("./CreaAsta.vue?vue&type=template&id=fcb31d8a&scoped=true&", function () {
      api.rerender('fcb31d8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/CreaAsta.vue"
export default component.exports